import { RecentlyDeceacedModule } from '../../../components/components/recentlyDeceacedModule/RecentlyDeceacedModule'
import { UpcomingFuneralsModule } from '../../../components/components/upcomingFuneralsModule/UpcomingFuneralsModule'

export default function RandomCTO() {
    return (
        <>
            {Math.round(Math.random()) === 0 ? (
                <RecentlyDeceacedModule />
            ) : (
                <UpcomingFuneralsModule />
            )}
        </>
    )
}
